import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, Ref, onMounted, onUnmounted } from 'vue';
import CommonModal from './CommonModal.vue';
import LoadingModal from './LoadingModal.vue';
import AlertModal from './AlertModal.vue';
import TextAreaInput from '../TextAreaInput.vue';
import Datepicker from '@vuepic/vue-datepicker';
import CommonToggle from '@/components/CommonToggle.vue';
import EditValueComponent from '@/components/EditValueComponent.vue';
import CommonButton from '../CommonButton.vue';
import StaffComponent from '../StaffComponent.vue';
import { AlertModalInjection, LoadingModalInjection } from '@/infra/constants/injections';
import CurrencyValue from '@/components/CurrencyValue.vue';
import { useRouter } from 'vue-router';
import { routes } from '@/router';
import { useCreateBasketPlanStore } from '@/stores/basket_plans/create_basket_plan_store';
import { BranchAddresses } from '@/models/branch_addresses_model';
import FormatUtils from '@/utils/format_utils';
import { useRequestRenew, RequestRenewPages } from '@/stores/requestRenew/request_renew_basket_plan_store';
import DeliverySelector from '../custom_selector/DeliverySelector.vue';
import { BasketPlan } from '@/models/basket_plans/basket_plan_model';
import BasketPlanCard from '../single_delivery_area_view/BasketPlanCard.vue';
import UsersCounter from '../UsersCounter.vue';
import PaymentMethodCard from '../payment_method/PaymentMethodCard.vue';
import { PaymentMethodTypes } from '@/models/payment_method/payment_method_types_enum';
import { MinimizedType } from '@/stores/minimized_modal_store/minimized_modal_store';
import { DeliveryType } from '@/models/delivery_type_enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestRenewBasketPlanModal',
  setup(__props, { expose: __expose }) {

const loadingModal = inject<Ref<InstanceType<typeof LoadingModal>>>(LoadingModalInjection);
const createBasketPlanStore = useCreateBasketPlanStore;
const alertModal = inject<Ref<InstanceType<typeof AlertModal>>>(AlertModalInjection);
const requestRenewBasketPlanModal = ref<InstanceType<typeof CommonModal>>();
const deliverySelector = ref<InstanceType<typeof DeliverySelector>>();
const deliveryType = ref<DeliveryType | null>(null);
const pickupBranchId = ref<string | null>(null);
const editValueComponent = ref<InstanceType<typeof EditValueComponent>>();
const deliveryAreaId = ref<string>();
const basketValue = ref<string>();
const router = useRouter();
const zIndex = ref(0);
const lastUpdateuser = ref<Date | null>();
const requestRenew = useRequestRenew;
const basketPlan = ref<BasketPlan | null>(null);
const isMouseOver = ref(false);

__expose({
  open: async (params: {
    basketPlan: BasketPlan | null,
    zIndex?: number
  }) => {
    clearModal();
    try {
      const promise = requestRenewBasketPlanModal.value?.open({
        zIndex: params.zIndex,
        name: `Renovação ${params.basketPlan?.getName()}`,
      });
      zIndex.value = params.zIndex ?? 1000;
      deliveryAreaId.value = params.basketPlan?.getDeliveryAreaId() ?? "";
      requestRenew.basketPlanId = params.basketPlan?.getId();
      requestRenew.basketName = params.basketPlan?.getName();
      basketValue.value = FormatUtils.formatMoney(FormatUtils.replaceDecimalSeparator(params.basketPlan?.getValue().toString() ?? ''));
      requestRenew.checkValue = false;
      requestRenew.deliveryType = undefined;
      requestRenew.basketValue = FormatUtils.formatMoney(FormatUtils.replaceDecimalSeparator(params.basketPlan?.getValue().toString() ?? ''));
      requestRenew.usersCount = params.basketPlan?.getUsersCount() ?? undefined;
      lastUpdateuser.value = params.basketPlan?.getUsersListUpdatedAt();
      basketPlan.value = params.basketPlan;
      await createBasketPlanStore.fetchBranches({
        deliveryAreaId: deliveryAreaId.value,
      });
      await promise;
    } catch (error) {
      console.error('An error occurred:', error);
    }
  },
  close: () => {
    createBasketPlanStore.$reset();
    clearModal();
    requestRenewBasketPlanModal.value?.close();
  },
});

function clearModal() {
  editValueComponent.value?.resetHasAlteration();
  requestRenew.$reset();
  createBasketPlanStore.$reset();
  requestRenewBasketPlanModal.value?.close();
}

async function requestRenewBasketPlan() {
  try {
    loadingModal?.value?.open();
    const res = await requestRenew.submit();
    if (res) clearModal();
  } finally {
    loadingModal?.value?.close();
  }
}

function goToScreen(params: {
  routeName: string;
}) {
  requestRenewBasketPlanModal.value?.minimize();
  router.push({
    name: params.routeName,
    params: {
      deliveryAreaId: deliveryAreaId.value
    }
  });
}

function goToPage(page: RequestRenewPages) {
  requestRenew.branchId = pickupBranchId.value ?? undefined;
  requestRenew.deliveryType = deliveryType.value!;
  const res = requestRenew.goToPage(page);
  if (res.getValue()) {
    requestRenewBasketPlanModal.value?.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));

function getMinDeliveryDate() {
  const limitDate = requestRenew.deliveryDateUtc ?? tomorrow;
  return new Date(new Date(limitDate).setDate(new Date(limitDate).getDate() + 1));
}

function closeAlteration() {
  const hasAlteration = editValueComponent.value?.getHasAlteration();
  if (hasAlteration?.value && !isMouseOver.value) {
    editValueComponent.value?.resetHasAlteration();
  }
}


const __returned__ = { loadingModal, createBasketPlanStore, alertModal, requestRenewBasketPlanModal, deliverySelector, deliveryType, pickupBranchId, editValueComponent, deliveryAreaId, basketValue, router, zIndex, lastUpdateuser, requestRenew, basketPlan, isMouseOver, clearModal, requestRenewBasketPlan, goToScreen, goToPage, tomorrow, getMinDeliveryDate, closeAlteration, CommonModal, TextAreaInput, get Datepicker() { return Datepicker }, CommonToggle, EditValueComponent, CommonButton, StaffComponent, CurrencyValue, get routes() { return routes }, get FormatUtils() { return FormatUtils }, get RequestRenewPages() { return RequestRenewPages }, DeliverySelector, BasketPlanCard, UsersCounter, PaymentMethodCard, get PaymentMethodTypes() { return PaymentMethodTypes }, get MinimizedType() { return MinimizedType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})